import React from 'react';
import { FadeIn } from './FadeIn';
import { SafeImage } from './SafeImage';
import { WhatsAppButton } from './WhatsAppButton';
interface AboutZevProps {
  /** 'body' omits the section heading + tagline, for pages that already state them. */
  variant?: 'full' | 'body';
}
export function AboutZev({
  variant = 'full'
}: AboutZevProps) {
  const showHeading = variant === 'full';
  return <section id="about" className="relative scroll-mt-20 bg-creamDeep px-6 py-20 md:px-12 md:py-32" data-id="element-13" data-mp="2s0za5wg08ugb">
      <div className="mx-auto max-w-6xl" data-id="element-14" data-mp="2n2o29r99su0q">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-20" data-id="element-15" data-mp="2n3pfo2drdslm">
          {/* Image side */}
          <div className="relative lg:col-span-6" data-id="element-16" data-mp="31t543bpthly5">
            <FadeIn data-id="element-17" data-mp="2x023ijmmhc8g">
              <div className="relative mx-auto aspect-[3/4] w-full max-w-md overflow-hidden rounded-sm lg:max-w-none" data-id="element-18" data-mp="2wyr2usoh4klk">
                <SafeImage src="https://a0.muscache.com/im/pictures/user/User-23169165/original/34c0edf4-86f2-420d-9ab5-075f889acc9f.jpeg?im_w=720" fallbackSrc="https://cdn.magicpatterns.com/uploads/kEWdox2XZmrj2PeAtGRtko/549193096_122201298908570946_2685253799441819983_n.jpg" alt="Zev Gelber, founder of Pines Retreat" className="h-full w-full object-cover" data-id="element-19" data-mp="298mz8lbackuk" />
              </div>
            </FadeIn>
            <FadeIn delay={0.3} className="absolute -bottom-8 -right-4 z-10 hidden h-48 w-48 lg:block" data-id="element-20" data-mp="2nvmb9ygwo5ad">
              <div className="h-full w-full overflow-hidden rounded-sm border-4 border-creamDeep shadow-xl" data-id="element-21" data-mp="1v7gshh9ewqd6">
                <img src="https://cdn.magicpatterns.com/uploads/7Qys8tKbwECbxzbYaa92kV/472354039_122134502762570946_1769931133132476279_n.jpg" alt="Zev with a friend at the retreat" className="h-full w-full object-cover" data-id="element-22" data-mp="206a1oxho1v7j" />
              </div>
            </FadeIn>
          </div>

          {/* Text side */}
          <div className="lg:col-span-6 lg:pl-8" data-id="element-23" data-mp="2qwxjhlbfzhmh">
            {showHeading && <>
                <FadeIn data-id="element-24" data-mp="2lxuneqdfwlqn">
                  <p className="mb-4 text-xs font-medium uppercase tracking-[0.2em] text-clay/70" data-id="element-25" data-mp="2lym9nal5d749">
                    About
                  </p>
                </FadeIn>
                <FadeIn delay={0.1} data-id="element-26" data-mp="2vw0nr3jlljte">
                  <h2 className="mb-6 font-serif text-4xl text-pine md:text-5xl" data-id="element-27" data-mp="2vx23vmfh0whz">
                    Meet Zev
                  </h2>
                </FadeIn>
                <FadeIn delay={0.15} data-id="element-28" data-mp="237d2h7yumufu">
                  <p className="mb-8 font-serif text-2xl leading-snug text-pine/90 md:text-3xl" data-id="element-29" data-mp="238eb75se74ue">
                    A place to slow down, reconnect and leave feeling better than when you
                    arrived.
                  </p>
                </FadeIn>
              </>}
            <FadeIn delay={0.2} data-id="element-30" data-mp="1pf59lraornmf">
              <p className="mb-6 text-lg font-light leading-relaxed text-clay" data-id="element-31" data-mp="1pe3vtf2acn10">
                Zev brings together facilitation, music, cold and hot exposure, sauna, and
                community-building to create spaces where people can slow down, reconnect,
                have fun and leave a different person than when they arrived.
              </p>
            </FadeIn>
            <FadeIn delay={0.25} data-id="element-32" data-mp="3m7c7xri2e4ks">
              <p className="mb-10 font-light leading-relaxed text-clay/90" data-id="element-33" data-mp="3m3y92t8m0di3">
                He's a social worker, ice bath facilitator, musician, and long-time
                community builder. Pines Retreat is an extension of how he shows up: warm,
                honest, and ready to hold whatever you bring.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-34" data-mp="9nkt3468fmbq">
              <div className="mb-10 flex flex-wrap gap-2" data-id="element-35" data-mp="9ocr0lnaxw56">
                {['Ice Bath Facilitator', 'Social Worker', 'Musician', 'Retreat Facilitator'].map(tag => <span key={tag} className="rounded-full border border-pine/15 bg-cream px-4 py-1.5 text-sm text-pine" data-id="element-36" data-mp="2yhhxfgl7ws3p">
                    {tag}
                  </span>)}
              </div>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-37" data-mp="34x08azevsrhk">
              <WhatsAppButton variant="link" label="Message Zev on WhatsApp" data-id="element-38" data-mp="34yb9qskutn5i" />
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}